import { render, staticRenderFns } from "./OilSamples.vue?vue&type=template&id=41414cdc"
import script from "./OilSamples.vue?vue&type=script&lang=js"
export * from "./OilSamples.vue?vue&type=script&lang=js"
import style0 from "./OilSamples.vue?vue&type=style&index=0&id=41414cdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports